<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import ReportPageHeader from "@/components/report-page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
// import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { manageReportService } from "../../../../services/managements/reports/report.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Debt Amount Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    ReportPageHeader,
    Button,
    // Input,
    Select, 
  },
  data() {
    return {
      title: "Debt Amount Report",
      data: [],
      projects: {},

      dataProjectId: 0,
      dataMonth: (moment().month() + 1) <10 ? '0'+(moment().month() + 1): (moment().month() + 1),
      dataYear: moment().year(),
      dataStartDate: '',
      dataEndDate: '',
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadReport();
    
  },
  methods: {
    
    loadReport: function() {
      let data = '?project_id='+this.dataProjectId+
        '&month='+this.dataMonth+
        '&year='+this.dataYear
      
      manageReportService.getDebtAmountReport(data)
        .then(response => {
          console.log(response);
          this.data = response.data;
        });
        
    },
    submitSearch: function() {
      this.loadReport();
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    moment: function () {
      return moment();
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '$0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    total(column_name, data){
      if(data){
        let total = 0;
        data.map(function(item){
            total += item[column_name];
        });

        return total;
      }
     
     
    }
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="'របាយការណ៍ប្រាក់ជំពាក់'" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <label>គម្រោង</label>
                <Select
                  :id="'id'"
                  :text="'name'"
                  :editable="true"
                  :list="{data: this.data.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <!-- <div class="col-sm-2">
                <label>ខែ</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.months}"
                  v-model="dataMonth"
                /> 
              </div> -->
              
               <div class="col-sm-2">
                 <label>ឆ្នាំ</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.years}"
                  v-model="dataYear"
                /> 
              </div>
              <div class="col-sm-2 pt-2">
                <br>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <ReportPageHeader
              :title="'របាយការណ៍ប្រាក់ជំពាក់'"
              :titleDate="this.data.date?('គិតចាប់ពី'+this.data.date.start_date + ' ដល់' + this.data.date.end_date):''"
            />
            <br/>

            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th class="text-center">លរ</th>
                  <th class="text-center">យូនីត</th>
                  <th class="text-center">បំណុលប្រព័ន្ធចាស់</th>
                  <th class="text-center">បំណុលឆ្នាំចាស់</th>
                  <th class="text-center" v-for="(month, index) in data.date.months" :key="index">
                    {{month.label}}
                  </th>
                  <th>សរុប</th>
                  
                </tr>
              
              <tbody>
                <tr  v-for="(list, index) in data.debt_amount" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{(list.unit)}}</td>
                  <td>{{formatCurrency(list.open_credit)}}</td>
                  <td>{{formatCurrency(list.dept_last_year )}}</td>
                  <td>{{formatCurrency(list.january)}}</td>
                  <td>{{formatCurrency(list.february)}}</td>
                  <td>{{formatCurrency(list.march)}}</td>
                  <td>{{formatCurrency(list.april)}}</td>
                  <td>{{formatCurrency(list.may)}}</td>
                  <td>{{formatCurrency(list.june)}}</td>
                  <td>{{formatCurrency(list.july)}}</td>
                  <td>{{formatCurrency(list.august)}}</td>
                  <td>{{formatCurrency(list.september)}}</td>
                  <td>{{formatCurrency(list.october)}}</td>
                  <td>{{formatCurrency(list.november)}}</td>
                  <td>{{formatCurrency(list.december)}}</td>
                  <td>{{formatCurrency(list.total)}}</td>
                </tr>
                <tr class="bg-warning">
                  <td colspan="2"></td>
                  <td>{{formatCurrency(total('open_credit', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('dept_last_year', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('january', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('february', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('march', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('april', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('may', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('june', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('july', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('august', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('september', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('october', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('november', this.data.debt_amount))}}</td>
                  <td>{{formatCurrency(total('december', this.data.debt_amount))}}</td>
                  <td >{{formatCurrency(total('total', this.data.debt_amount))}}</td>
                </tr>
              </tbody>
            </table>
            <div class="row mt-2">
              <div class="col">
                <h5 class="float-end">សរុបរួម៖ {{formatCurrency(total('total', this.data.debt_amount) + total('dept_last_year', this.data.debt_amount) + total('open_credit', this.data.debt_amount) ) }}</h5>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col text-center">
                <p>ឯកភាព និងទទួលស្គាលើដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>លោកនាយកក្រុមហ៊ុន</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>អ្នកគ្រប់គ្រងទូទៅ</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>ជំនួយការអ្នកគ្រប់គ្រង</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>បុគ្គលិក</p>
              </div>
            </div>
            <br>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>